import { z } from "zod";

import { EMAIL_REGEX, NAME_REGEX } from "@luce/core/constants";

export const MAX_EMAIL_FIELDS = 3;
export const MAX_PHONE_FIELDS = 3;

const emailRow = z.object({
  value: z.string().min(1, "Email is required").regex(EMAIL_REGEX, "Invalid email"),
});

const phoneRow = z.object({
  value: z.string().min(4, "Phone number is required"),
});

export const contactSchema = z.object({
  firstName: z
    .string()
    .min(1, "First name is required")
    .regex(NAME_REGEX, "Please avoid using special characters"),
  lastName: z
    .string()
    .min(1, "Last name is required")
    .regex(NAME_REGEX, "Please avoid using special characters"),
  email: z.array(emailRow).min(1).max(MAX_EMAIL_FIELDS),
  phoneNumber: z.array(phoneRow).min(1).max(MAX_PHONE_FIELDS),
  primary: z.boolean(),
});

export type ContactFormValues = z.input<typeof contactSchema>;

export const emptyContactValues: ContactFormValues = {
  firstName: "",
  lastName: "",
  email: [{ value: "" }],
  phoneNumber: [{ value: "+65" }],
  primary: false,
};

export function ensurePhoneNumberWithPlus(phoneNumber: string): string {
  return phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
}

export function flattenRows(rows: { value: string }[]): string[] {
  return rows.map((row) => row.value);
}
